<ng-container *ngIf="transferredItems$ | async as transferredItems">
  @if (transferredItems?.length > 0) {
    <div class="wallet-transferred-list border rounded">
      @for (item of transferredItems; track item.Id) {
        <div class="wallet-transferred-list-item">
          <div class="img-wrapper">
            <img [src]="item.Image | contentImage: '7'" alt="Transferred Item" />
          </div>
          <div class="wallet-transferred-item-list-content">
            <div class="wallet-transferred-list-item-desc">
              <div class="wallet-transferred-list-item-item-name">{{ item.Name }}</div>
              <div class="wallet-transferred-list-item-footer">
                @if (item.ExpireDate) {
                  <div class="wallet-transferred-list-item-item-expiry">
                    {{ 'fgbcl.wallet.transferred.list.item.expire' | translate }}
                    {{ item.ExpireDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
                  </div>
                }
                <div class="wallet-transferred-list-item-transferred-name">
                  {{ 'fgbcl.wallet.transferred.list.item.transferred.to' | translate }} {{ item.TransferMemberName }} ({{
                    'fgbcl.wallet.transferred.list.item.transferred.to.member.id' | translate
                  }}
                  - {{ item.TransferMemberId }})
                </div>
              </div>
            </div>
            <div class="wallet-transferred-list-item-action-wrapper">
              <button class="btn btn-danger fw-bold" (click)="openCallbackModal(callbackItemModal, item)">
                <i class="material-symbols-outlined">reply_all</i
                >{{ 'fgbcl.wallet.transferred.list.callback.button' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</ng-container>

<!-- Callback Modal -->
<ng-template #callbackItemModal let-modal>
  <div class="wallet-transfer-item-callback-modal-content">
    <div class="wallet-transfer-item-callback-modal-header">
      <h6 class="mb-0">{{ 'fgbcl.marketplace.wallet.callback.modal.title' | translate }}</h6>
    </div>
    <hr class="m-0" />
    <div class="wallet-transfer-item-callback-modal-body">
      <p class="mb-0">{{ 'fgbcl.wallet.callback.message' | translate }}</p>
      @if (hasError) {
        <div class="error-message">
          {{ 'fgbcl.marketplace.wallet.transfer.item.error.' + errorCode | translate }}
        </div>
      }
    </div>
    <hr class="m-0" />
    <div class="wallet-transfer-item-callback-modal-footer">
      <button class="btn text-danger fw-bold me-2" (click)="modal.close()">
        {{ 'fgbcl.wallet.callback.button.cancel' | translate }}
      </button>
      <button class="btn btn-success fw-bold" (click)="callBack()">
        {{ 'fgbcl.wallet.callback.button.ok' | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- End Callback Modal -->
